import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notificacao',
  standalone: true,
  imports: [],
  templateUrl: './notificacao.component.html',
  styleUrl: './notificacao.component.scss'
})
export class NotificacaoComponent implements OnInit {

  @Input() titulo = null;
  @Input() mensagem = null;

  @Output() fechou = new EventEmitter();

  temporizador: any;
  animacaoLoader = true
  darkMode = false

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router
  ){}

  ngOnInit(): void {
    this.mensagem = this.sanitizer.bypassSecurityTrustHtml(this.mensagem);
    this.definirTema();
    this.iniciarTemporizador();
  }

  definirTema(){
    if ($('#body').hasClass('dark')){
      this.darkMode = true
    }
  }

  iniciarTemporizador() {
    this.temporizador = setTimeout(() => {
      this.fechar();
    }, 5000);
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.animacaoLoader = false;
    clearTimeout(this.temporizador);
  }
  
  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.temporizador) {
      clearTimeout(this.temporizador);
    }
    this.iniciarTemporizador();
    this.animacaoLoader = true;
  }

  fechar(irParaHistorico: boolean = false) {
    if(irParaHistorico) this.router.navigate(["/historico-versoes"]);
    
    this.fechou.emit("fechou");
  }

}
